import { api1C, api1CDocs } from './api';

export const create1cDocuments = (params) => api1C.post('documents', params);

export const getRawDocument = (url) => api1CDocs.get('document-bin', { params: {url}});
